/** Client-side HTML sanitization for notes display (defense in depth with server strip_tags). */
export function sanitizeHtml(html: string): string {
  if (!html) return ''
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    doc.querySelectorAll('script, iframe, object, embed, form, link, meta').forEach((el) => el.remove())
    doc.querySelectorAll('*').forEach((el) => {
      ;[...el.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase()
        if (name.startsWith('on') || name === 'style' || name === 'formaction') {
          el.removeAttribute(attr.name)
        }
        if (name === 'href' || name === 'src') {
          const val = (attr.value || '').trim().toLowerCase()
          if (val.startsWith('javascript:') || val.startsWith('data:')) {
            el.removeAttribute(attr.name)
          }
        }
      })
    })
    return doc.body.innerHTML
  } catch {
    return ''
  }
}
